// src/utils/lab-config.js
export function labConfig() {
    return {
      name: "Laboratorio de Instrumentación",
      cuit: "30-71414789-3",
      address: "Carril Rodríguez Pella 2065. CP 5511,Maipu-Mendoza-Argentina",
      city: "Mendoza",
      country: "Argentina",
      phone: "+54 261 5322685",
      email: "ventas@calins.com.ar",
      // logoBase64: "data:image/png;base64,...." // opcional
    };
  }
  